angular.module('myApp.services')
    .factory('formaters', function() {
        var maxLRDuration               = 10000;        //just to fill in chartXLabels
        var secondsFormaters            = [];
        var formatData = function(seconds) {
            seconds = parseInt(seconds);
            return new Date(seconds*1000).toUTCString().split(/ /)[4].substr(-7);
        };
        for (var i = 0; i <= maxLRDuration; i++) {
            secondsFormaters[i] = formatData(i);
        }

        return {
            formatLRSecond: function(sec) {
                return secondsFormaters[parseInt(sec)];
            },
            formatDuration: function (duration) {
                duration    = parseFloat(duration);
                var result  = '';
                if (duration) {
                    var mins    = Math.floor(duration/60);
                    var secs    = Math.round(duration - mins*60);
                    if (mins > 0) {
                        result += (mins < 10) ? ('0' + mins) : mins;
                    }
                    result += ':';
                    result += (secs < 10) ? ('0' + secs) : secs;
                }
                return result;
            },
            formatUserMediaDuration: function(duration, alwaysShowMinutes = false) {
                let result = '';
                let fileLength  = Math.round(parseFloat(duration));
                let minutes     = Math.floor(fileLength / 60);
                let seconds     = fileLength - minutes * 60;
                if (minutes > 0) {
                    result += minutes < 10 ? ('0' + minutes) : minutes;
                } else if (alwaysShowMinutes) {
                    result += '00';
                }
                result += ':';
                result += seconds < 10 ? ('0' + seconds) : seconds;
                return result;
            }
        }
    });